export default __webpack_public_path__ + "static/media/330_dummy2016-kuenstler02-de.667143e7.png";